import * as React from 'react';
import { IApp } from '../App';
import app from '..';

export const StoreContext = React.createContext<NonNullable<IApp['model']>>(null as any);
export const MSTProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <StoreContext.Provider value={app.model}>{children}</StoreContext.Provider>
);
